import { render, staticRenderFns } from "./coursePage2.vue?vue&type=template&id=3ea3825c&scoped=true"
import script from "./coursePage2.vue?vue&type=script&lang=js"
export * from "./coursePage2.vue?vue&type=script&lang=js"
import style0 from "./coursePage2.vue?vue&type=style&index=0&id=3ea3825c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea3825c",
  null
  
)

export default component.exports